export const getSafeRedirectPath = (redirect, fallback) => {
	if (
		typeof redirect === 'string' &&
		redirect.startsWith('/') &&
		!redirect.startsWith('//')
	) {
		return redirect
	}

	return fallback
}

export const getSafeRedirectQuery = redirect => {
	const path = getSafeRedirectPath(redirect, null)

	return path ? { redirect: path } : {}
}
